import { useCallback } from "react";
import { DataGridPro as MuiDataGrid } from "@mui/x-data-grid-pro";
import {
  ChevronRight as MuiChevronRightIcon,
  ExpandMore as MuiExpandMoreIcon,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import VersionPreview from "./VersionPreview";

export const tableStyles = {
  height: "calc(100vh - 289px)",
  paddingTop: "24px",
  borderRadius: "0px",
  borderWidth: "0px",
  width: "auto",
  "&  .MuiDataGrid-columnSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-cell": {
    display: "flex",
    alignItems: "center",
  },
  "& .MuiDataGrid-container--top [role=row]": {
    backgroundColor: "#666666",
    color: "white",
    borderRadius: "0px",
  },
  "& .MuiDataGrid-columnHeader:focus": {
    outline: "none !important",
  },
  "& .MuiDataGrid-columnHeader:focus-within": {
    outline: "none !important",
  },
  "& .MuiDataGrid-cell:focus": {
    outline: "none !important",
  },
  "& .MuiDataGrid-cell:focus-within": {
    outline: "none !important",
  },
  "& .MuiDataGrid-scrollbar--horizontal ": {
    display: "none",
  },
  "& .MuiDataGrid-filler": {
    display: "none",
  },
};

const VersionsTable = ({ versions }) => {
  const { t } = useTranslation();

  const columns = [
    {
      field: "id",
      headerName: t("studyRecruitment.versions.table.version"),
      sortable: false,
      width: 100,
    },
    {
      field: "status",
      headerName: t("studyRecruitment.versions.table.status"),
      sortable: false,
      width: 132,
    },
    {
      field: "changedOn",
      headerName: t("studyRecruitment.versions.table.changedOn"),
      sortable: false,
      width: 200,
    },
    {
      field: "changedBy",
      headerName: t("studyRecruitment.versions.table.changedBy"),
      sortable: false,
      width: 220,
    },
  ];

  const getDetailPanelContent = useCallback(({ row }) => {
    return <VersionPreview version={row.version} />;
  }, []);

  const getDetailPanelHeight = useCallback(() => "auto", []);

  return (
    <MuiDataGrid
      slots={{
        detailPanelExpandIcon: MuiChevronRightIcon,
        detailPanelCollapseIcon: MuiExpandMoreIcon,
      }}
      disableColumnMenu
      disableColumnResize
      disableColumnReorder
      disableColumnFilter
      disableColumnSelector
      disableDensitySelector
      disableMultipleColumnsSorting
      disableMultipleRowSelection
      disableRowSelectionOnClick
      hideFooter
      rows={versions}
      columns={columns}
      getDetailPanelContent={getDetailPanelContent}
      getDetailPanelHeight={getDetailPanelHeight}
      sx={tableStyles}
    />
  );
};

export default VersionsTable;
